import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { stagger, titleChar, tapScale } from '../motion';
import { titlePhrases } from './titlePhrases';

interface Props {
  title: string;
  back?: string | boolean;
  actions?: React.ReactNode;
}

/** 全画面共通の見出し。文字が1つずつ立ち上がる。折り返すときは文節の切れ目で折る */
export const PageHeader: React.FC<Props> = ({ title, back, actions }) => {
  const navigate = useNavigate();
  return (
    <header className="v2-header">
      <div className="v2-header-lead">
        {back && (
          <motion.button
            className="v2-back"
            whileTap={tapScale}
            whileHover={{ x: -2 }}
            aria-label="戻る"
            onClick={() => (typeof back === 'string' ? navigate(back) : navigate(-1))}
          >
            <ChevronLeft size={20} />
          </motion.button>
        )}
        <motion.h1 className="v2-title" variants={stagger(0.04)} initial="hidden" animate="show" aria-label={title}>
          {titlePhrases(title).map((phrase, p) =>
            /^\s+$/.test(phrase) ? (
              ' '
            ) : (
              <span key={`${phrase}-${p}`} className="v2-title-phrase" aria-hidden>
                {Array.from(phrase).map((ch, i) => (
                  <motion.span key={`${ch}-${i}`} variants={titleChar}>
                    {ch}
                  </motion.span>
                ))}
              </span>
            ),
          )}
        </motion.h1>
      </div>
      {actions && (
        <motion.div
          className="v2-header-actions"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          {actions}
        </motion.div>
      )}
    </header>
  );
};
